/* =========================================================
   PRODUKTSEITE „ATELIER“
   Galerie (Bühne, Lupe, Wischen, Vollbild), Reiter,
   Lieferfenster und Größentabelle. Varianten, Preise und
   Warenkorb übernimmt main.js – hier wird nur die Galerie
   mit der gewählten Variante verbunden.
   ========================================================= */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init() {
    var root = $('[data-pd]');
    if (!root || root.hasAttribute('data-pd-ready')) return;
    root.setAttribute('data-pd-ready', '');

    var mobile = window.matchMedia('(max-width: 989px)');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    var variants = [];
    try { variants = JSON.parse($('[data-product-variants]', root).textContent); } catch (e) {}

    /* ---------- Galerie ---------- */
    var stage = $('.lv-pd-gal__stage', root);
    var track = $('[data-pd-track]', root);
    var slides = $$('[data-pd-slide]', root);
    var thumbs = $$('[data-pd-thumb]', root);
    var current = $('[data-pd-current]', root);
    var bar = $('[data-pd-bar]', root);
    var prev = $('[data-pd-prev]', root);
    var next = $('[data-pd-next]', root);
    var active = 0;
    var lock = false;
    var lockTimer;

    function mark(i) {
      active = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) {
          t.setAttribute('aria-current', 'true');
          var rail = t.parentNode;
          var top = t.offsetTop - rail.clientHeight / 2 + t.clientHeight / 2;
          if (rail.scrollHeight > rail.clientHeight) rail.scrollTo({ top: top, behavior: 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      if (current) current.textContent = pad(i + 1);
      if (bar && slides.length) bar.style.left = (100 / slides.length) * i + '%';
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (mobile.matches && track) {
        lock = true;
        clearTimeout(lockTimer);
        lockTimer = setTimeout(function () { lock = false; }, 700);
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }
      mark(i);
    }

    /* Bild -> Variante */
    function variantForSlide(i) {
      var id = slides[i] && slides[i].getAttribute('data-media-id');
      if (!id) return null;
      return variants.filter(function (v) { return v.featured_media && String(v.featured_media.id) === String(id); })[0] || null;
    }

    function selectVariant(v) {
      if (!v) return;
      var groups = $$('[data-option]', root);
      var changed = null;
      groups.forEach(function (g, k) {
        var val = v.options[k];
        var sel = $('select', g);
        if (sel) { if (sel.value !== val) { sel.value = val; changed = sel; } return; }
        $$('input', g).forEach(function (inp) {
          if (inp.value === val && !inp.checked) { inp.checked = true; changed = inp; }
        });
      });
      if (changed) {
        syncing = true;
        changed.dispatchEvent(new Event('change', { bubbles: true }));
        syncing = false;
      }
    }

    var syncing = false;

    function userGo(i) {
      goTo(i, true);
      selectVariant(variantForSlide(i));
    }

    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { userGo(k); }); });
    if (prev) prev.addEventListener('click', function () { userGo(active - 1); });
    if (next) next.addEventListener('click', function () { userGo(active + 1); });

    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== active) {
            mark(i);
            if (!lock) selectVariant(variantForSlide(i));
          }
        }, 80);
      }, { passive: true });
    }

    /* Variante -> Bild */
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var finishEl = $('[data-pd-finish]', root);
    if (form) {
      form.addEventListener('change', function () {
        setTimeout(function () {
          var id = idInput && idInput.value;
          var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
          if (!v) return;
          if (finishEl) {
            var t = (v.title || '').toLowerCase();
            if (t.indexOf('vergoldet') > -1 || t.indexOf('gold') > -1) finishEl.textContent = 'Vergoldet';
            else if (t.indexOf('rosé') > -1 || t.indexOf('rose') > -1) finishEl.textContent = 'Rosé vergoldet';
            else if (t.indexOf('silber') > -1 || t.indexOf('silver') > -1) finishEl.textContent = 'Silber';
          }
          if (syncing || !v.featured_media) return;
          var idx = -1;
          slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(v.featured_media.id)) idx = k; });
          if (idx > -1 && idx !== active) goTo(idx, true);
        }, 0);
      });
    }

    /* Lupe (nur Maus) */
    if (stage) {
      stage.addEventListener('mousemove', function (e) {
        if (!fine.matches || mobile.matches) return;
        if (e.target.closest('button')) { stage.classList.remove('is-zoom'); return; }
        var img = slides[active] && slides[active].querySelector('img');
        if (!img) return;
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
        stage.classList.add('is-zoom');
      });
      stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
      stage.addEventListener('click', function (e) {
        if (e.target.closest('[data-pd-prev],[data-pd-next]')) return;
        openLb(active);
      });
    }

    /* ---------- Vollbild ---------- */
    var lb = $('[data-pd-lightbox]', root);
    var lbImg = lb && $('[data-pd-lb-img]', lb);
    var lbCount = lb && $('[data-pd-lb-count]', lb);
    var lbIndex = 0;
    var lastFocus = null;

    function showLb(i) {
      if (!slides.length) return;
      lbIndex = (i + slides.length) % slides.length;
      var s = slides[lbIndex];
      var src = s.getAttribute('data-full') || (s.querySelector('img') || {}).currentSrc;
      lbImg.src = src || '';
      lbImg.alt = (s.querySelector('img') || {}).alt || '';
      lbCount.textContent = pad(lbIndex + 1) + ' / ' + pad(slides.length);
    }

    function openLb(i) {
      if (!lb) return;
      lastFocus = document.activeElement;
      showLb(i);
      lb.hidden = false;
      document.documentElement.classList.add('lv-pd-locked');
      $('[data-pd-lb-close]', lb).focus();
    }

    function closeLb() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.classList.remove('lv-pd-locked');
      goTo(lbIndex, false);
      if (lastFocus) lastFocus.focus();
    }

    if (lb) {
      $('[data-pd-lb-close]', lb).addEventListener('click', closeLb);
      $('[data-pd-lb-prev]', lb).addEventListener('click', function () { showLb(lbIndex - 1); });
      $('[data-pd-lb-next]', lb).addEventListener('click', function () { showLb(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      var tx = null;
      lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (tx === null) return;
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) showLb(lbIndex + (dx < 0 ? 1 : -1));
        tx = null;
      });
    }

    var openBtn = $('[data-pd-open]', root);
    if (openBtn) openBtn.addEventListener('click', function (e) { e.stopPropagation(); openLb(active); });
    $$('[data-pd-view]', root).forEach(function (b) {
      b.addEventListener('click', function () { openLb(parseInt(b.getAttribute('data-pd-view'), 10) || 0); });
    });

    /* ---------- Größentabelle ---------- */
    var sizes = $('[data-pd-sizes-panel]', root);
    function closeSizes() {
      if (!sizes || sizes.hidden) return;
      sizes.hidden = true;
      document.documentElement.classList.remove('lv-pd-locked');
    }
    $$('[data-pd-sizes]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!sizes) return;
        sizes.hidden = false;
        document.documentElement.classList.add('lv-pd-locked');
        $('[data-pd-sizes-close]', sizes).focus();
      });
    });
    if (sizes) {
      $('[data-pd-sizes-close]', sizes).addEventListener('click', closeSizes);
      sizes.addEventListener('click', function (e) { if (e.target === sizes) closeSizes(); });
    }

    document.addEventListener('keydown', function (e) {
      if (lb && !lb.hidden) {
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') showLb(lbIndex - 1);
        if (e.key === 'ArrowRight') showLb(lbIndex + 1);
        return;
      }
      if (e.key === 'Escape') closeSizes();
    });

    /* ---------- Reiter ---------- */
    var tabs = $$('[role="tab"]', root);
    function selectTab(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, k) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { selectTab(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = tabs[(k + d + tabs.length) % tabs.length];
        selectTab(n);
        n.focus();
      });
    });

    /* ---------- Lieferfenster ---------- */
    var win = $('[data-pd-window]', root);
    if (win) {
      var min = parseInt(root.getAttribute('data-lt-min'), 10) || 8;
      var max = parseInt(root.getAttribute('data-lt-max'), 10) || 12;
      if (max < min) max = min;
      try {
        var f = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
        var a = new Date(); a.setDate(a.getDate() + min);
        var b = new Date(); b.setDate(b.getDate() + max);
        win.textContent = 'zwischen ' + f.format(a) + ' und ' + f.format(b);
      } catch (e) {}
    }

    /* Start */
    var start = 0;
    slides.forEach(function (s, k) { if (s.hasAttribute('data-initial')) start = k; });
    goTo(start, false);
    mobile.addEventListener && mobile.addEventListener('change', function () { goTo(active, false); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
